// Categorias
(function () {
  'use strict';

  if ($('.form-blog-posts').length > 0) {
    const $categoriesList = $('#categorias-list');
    const $tableCategories = $categoriesList.find('table');
    const $categoriesId = $('#categorias');
    const textoLista = {
      empty: 'Nenhuma categoria encontrada.',
    };
    const htmlLinha = (item, isCategory = false) => `
    <tr data-row="${item['id']}">
      <td class="category-select-size">
        <div class="form-check">
          <input type="checkbox" name="ids[]" id="check-row-categorias-${item['id']}" class="check-row" value="${
      item['id']
    }">
          <label for="check-row-categorias-${item['id']}" title="Selecionar item"><span ${
      isCategory ? `style="font-weight: 600; padding-left: 5px;"` : 'style="padding-left: 5px;"'
    }>${item['title']}</span></label>
        </div>
      </td>
      <td data-label="Título" ${isCategory ? `style="font-weight: 600;"` : 'style="padding-left: 25px;"'}>
        ${item['title']}
      </td>
    </tr>
    `;

    function beforeBuscaCategorias() {
      $tableCategories.find('tbody').html('');
      $tableCategories.find('tbody').html(`
      <tr>
        <td colspan="2" class="p-0">
          <div class="loader-el-wrp active" style="min-height: 100px !important;">
            <div class="loader-container">
              <div class="loader-wrapper">
                <div class="loader"></div>
              </div>
            </div>
          </div>
        </td>
      </tr>`);
    }

    function buscaCategorias() {
      beforeBuscaCategorias();
      const url = $categoriesId.data('url');
      const data = {
        acao: 'busca_categorias',
      };
      return $.ajax({
        type: 'GET',
        url: url,
        data,
        dataType: 'json',
      });
    }
    buscaCategorias()
      .done((result) => {
        if (result.total > 0) {
          $tableCategories.find('tbody').html('');
          result['categorias'].forEach(function (item) {
            $tableCategories.find('tbody').append(htmlLinha(item, true));
            $tableCategories.find('tbody').find('input[type="checkbox"]').on('change', eventSelectCategory);
          });
        } else {
          $tableCategories.find('tbody').html(`
        <tr colspan="2">
          ${textoLista['empty']}
        </tr>`);
        }
      })
      .always(afterBuscaCategorias);

    function afterBuscaCategorias() {
      selecionaSelecionados();

      // Evento click na tabela
      $tableCategories.find('tr').on('click', tableRowClick);
    }

    function selecionaSelecionados() {
      if ($categoriesId.length > 0) {
        const ids = $categoriesId.val().split(',');
        ids.forEach(function (id) {
          $tableCategories.find(`tr[data-row="${id}"] input[type="checkbox"]`).prop('checked', true);
        });
        atualizaCheckbox();
      }
    }

    function tableRowClick(ev) {
      ev.stopPropagation();
      const $inptCheck = $(ev.target).closest('tr').find('input:checkbox');
      if (
        $inptCheck.length > 0 &&
        ev.target.tagName.toLowerCase() != 'label' &&
        ev.target.tagName.toLowerCase() != 'input'
      ) {
        $inptCheck.prop('checked', !$inptCheck.prop('checked')).trigger('change');
      }
    }

    // Atualiza a checkbox das categorais com sub
    function atualizaCheckbox() {
      // Pega somente os id das categorias que tem subcategoria
      let categoriasId = [
        ...new Set(
          $tableCategories
            .find(`tr[data-category-id]`)
            .toArray()
            .map((tr) => tr.dataset['categoryId']),
        ),
      ];
      categoriasId.forEach(function (categoryId) {
        const $rowCategory = $tableCategories.find('tbody').find(`[data-row="${categoryId}"]`);
        const $checkboxCategory = $rowCategory.find('input[type="checkbox"]');
        let subcategorias_habilitadas = $tableCategories
          .find('tbody')
          .find(`[data-category-id="${categoryId}"`)
          .filter(function (index) {
            return $(this).find('input[type="checkbox"]').is(':checked') === true;
          }).length;
        if (subcategorias_habilitadas == 0) {
          $checkboxCategory.prop('disabled', false);
        } else if ($checkboxCategory.is(':checked') == false) {
          $checkboxCategory.prop('checked', true);
        } else {
          $checkboxCategory.prop('disabled', true);
        }
      });
    }

    // Atualiza os ids selecionados
    function atualizaIds() {
      const ids = [];
      const $rowChecked = $tableCategories.find('tbody tr').filter(function (index) {
        return $(this).find('input[type="checkbox"]').is(':checked') === true;
      });
      $rowChecked.each(function (index) {
        ids.push($(this).data('row'));
      });
      $categoriesId.val(ids.join(','));
    }

    // Usuário selecionou alguma categoria
    function eventSelectCategory(ev) {
      const $row = $(ev.target).closest('tr');
      // Clicou em uma subcategoria
      if ($row.data('category-id')) {
        // Id da categoria associada a subcategoria
        // const categoryId = $row.data('category-id');
        atualizaCheckbox();
      }
      atualizaIds();
    }
  }
})();

// Escolhendo seo para postagem
(function () {
  'use strict';

  const $seoCategoria = $('#seo-blog-posts');
  if ($seoCategoria[0]) {
    // Variáveis
    const $campoDominio = $('#mplp_domain');
    const $campoTitle = $('#titulo');
    const $seoTitle = $('#seo_titulo');
    const $campoPag = $('#cat_pag');
    const $pagePreview = $('.category-url-preview-pag');

    // Ao cadastrar uma categoria e editar o título
    if ($seoTitle.length > 0 && $('input[name="acao"]').val() == 'insert') {
      $campoTitle.on('change', function () {
        $seoTitle.val($(this).val()).trigger('change');
      });
    }

    $seoTitle.on('change input', function (ev) {
      let slug = slugify($seoTitle.val());
      if ($campoPag.val().length == 0 || slug.substr(0, slug.length - 1) == $campoPag.val()) {
        $campoPag.val(slugify($(this).val())).trigger('change');
      }
    });

    // Ao alterar a url da página
    $campoPag.on('input change', handlePagLp);

    // Ao alterar a url da página
    handlePagLp();
    function handlePagLp() {
      let pag = $campoPag.val();
      if (pag == '' && $pagePreview.data('placeholder')) {
        $pagePreview.text($pagePreview.data('placeholder'));
      } else {
        $pagePreview.text(pag);
      }
    }
  }
})();
